export default {
	WIZARD_AB_TEST: 'wizard_ab_test',
	NEW: 'new',
};

export const UTM_PREFIX = 'utm_';
